// levels.js — Récupération CACHÉE du niveau d'un joueur (pour afficher un badge partout :
// chat, amis, salon…). Une seule requête par user_id, mémorisée en cache mémoire + dédup in-flight.
import { nakamaAuth } from './nakamaAuth';
import { levelForXp, statusForLevel } from './xpConfig';

const cache = new Map();     // userId -> { level, status } | null
const inflight = new Map();  // userId -> Promise

export async function getUserLevel(userId) {
  if (!userId) return null;
  if (cache.has(userId)) return cache.get(userId);
  if (inflight.has(userId)) return inflight.get(userId);
  const p = (async () => {
    try {
      const r = await nakamaAuth.rpc('vg_progress_get', { user_id: userId });
      // rpc() renvoie DÉJÀ un objet (le SDK parse le payload) → ne pas re-JSON.parse (cassait le badge).
      const d = typeof r === 'string' ? JSON.parse(r) : (r || null);
      const prog = d && d.progression;
      const xp = prog ? Number(prog.xp) || 0 : 0;
      const level = (prog && prog.level) || levelForXp(xp);
      const status = (prog && prog.status) || statusForLevel(level);
      const val = { level, status, xp };
      cache.set(userId, val);
      return val;
    } catch {
      cache.set(userId, null);
      return null;
    } finally {
      inflight.delete(userId);
    }
  })();
  inflight.set(userId, p);
  return p;
}

// Invalide le cache d'un user (ex: après un gain d'XP notable) — optionnel.
export function invalidateUserLevel(userId) { cache.delete(userId); }
